import Panorama from '@/models/Panorama';

export default {
  setData(state, data) {
    state.data = new Panorama(data);
  },
  setViewYaw(state, value) {
    state.viewYaw = value;
  },
  switchHotspot(state, value) {
    state.hotspot = value;
  },
};
